export default __webpack_public_path__ + "static/media/upload_background.0881cc87.webp";